<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{message}}</p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="false">{{cancelText}}</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{confirmText}}</button>
</div>
